import{post } from '@/utils/request';
import{filerequesturlPic } from '@/utils/baseUrl';


export async function getMDSysMessage(param) {
    return post('/masterData/getMDSysMessage',param,true)
}
export const filerequest_url=filerequesturlPic;
//获取主数据列表
export async function getEditMessage(param) {
    return post('/masterData/getEditMessage',param,true)
}
export async function replaceMasterData(param) {
    return post('/masterData/replaceMasterData',param,true)
}
export async function saveMDRelation(param) {
    return post('/masterData/saveMDRelation',param,true)
}
//新增产品
export async function saveMDSysMessage(param) {
    return post('/masterData/saveMDSysMessage',param,true)
}
//查看订阅
export async function getMDataDetails(param) {
    return post('/masterData/getMDataDetails',param,true)
}
export async function delMDRelation(param) {
    return post('/masterData/delMDRelation',param,true)
}
//编辑数据
export async function updateMDMessage(param) {
    return post('/masterData/updateMDMessage',param,true)
}
//重新发布
export  async  function republish() {
    return post('/masterData/republish',param,true)
}

///单位接口
export async function getDict(param) {
    return post('/masterData/getDict',param,true)
}
//产品flag类型列表
export async function listFlags(param) {
    return post('/masterData/listFlags',param,true)
}